import { Flex, Grid, Popover } from "antd";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { useMemo, useState } from "react";
import { EXCLUDED_FEATURE_IDS } from "../../constants/AppConstants";
import SavedTemplatesSelect from "../../pages/templates/SavedTemplatesSelect";
import { DateAndTimePickerComponent, SuggestReply } from "../../pages/utils/CommonVessels";
import EmojiWrapper from "../custom/EmojiWrapper";
import HToolTip from "../custom/info/HToolTip";
import HButton from "../custom/input/button/Button";
import MediaUploadIconWrapper from "../custom/MediaUploadIconWrapper";
import HNotification from "../custom/notification/HNotification";
import ReusableFilePreview from "../custom/ReusableFilePreview";
import VoiceRecordingButton from "./VoiceRecordingButton";
dayjs.extend(relativeTime);

function MessagingAreaActionItems(props) {
  const {
    handleMessage,
    source,
    fileList,
    setFileList,
    integrationId,
    chatView,
    iconsSize,
    hiddenItems = [],
    toggleDrawer,
    isContentPresent,
    showPreviewButton,
    contactId,
    message,
    setMessageAreaLoading,
    messageBodyRef,
    appProperties,
    prompt,
    handleOpenNotes,
    setIsAiGenerated = () => {},
    enabledCheck,
    cursorPositionRef,
    filesPreviewPosition = "top",
    moduleName,
    toNumber,
    handleMedia = () => {
      console.warn("handleMedia not provided");
    },
    setPreviewResponse,
    templateProps = {},
    disabled
  } = props;

  const { open: templateOpen, setOpen: setTemplateOpen } = templateProps;

  const { xs } = Grid.useBreakpoint();

  const excludedFeatures = appProperties?.excludedFeatures;

  const excludedActionItems = useMemo(() => {
    const fromAppProperties = excludedFeatures || new Set();
    const fromProps = hiddenItems || [];
    return new Set([...fromAppProperties, ...fromProps]);
  }, [excludedFeatures, hiddenItems]);

  const showSuggestReply = !excludedActionItems.has(EXCLUDED_FEATURE_IDS.AI_SUGGEST);
  const showAttachment = !excludedActionItems.has(EXCLUDED_FEATURE_IDS.ATTACHMENT);
  const showEmoji = !excludedActionItems.has(EXCLUDED_FEATURE_IDS.EMOJI);
  const showNotes = !excludedActionItems.has(EXCLUDED_FEATURE_IDS.NOTES);
  const showTemplateIcon = !excludedActionItems.has(EXCLUDED_FEATURE_IDS.SELECT_TEMPLATE);
  const showVoiceRecording = !excludedActionItems.has(EXCLUDED_FEATURE_IDS.VOICE_RECORDING);

  if (disabled) return null;

  return (
    <div className="w-100">
      {filesPreviewPosition === "bottom" && fileList?.length > 0 && (
        <div className="overflow-scroll">
          <ReusableFilePreview fileList={fileList} setFileList={setFileList} shape={"circle"} direction={"horizontal"} customClasses={"ps-3"} />
        </div>
      )}
      <Flex align="center" className={`"h-100`}>
        <Flex
          justify={"space-between"}
          align={"center"}
          className={`hs-max-h-50-px rounded-top ${source === "campaign" ? "hs-w-95" : "hs-w-98"}`}
        >
          <div className="d-flex gap-md-2 gap-sm-1 align-items-center w-100 h-100">
            {showSuggestReply && (
            <SuggestReply
              setIsAiGenerated={setIsAiGenerated}
              enabledCheck={enabledCheck}
              ref={messageBodyRef}
              appProperties={appProperties}
              prompt={prompt}
              setMessageAreaLoading={setMessageAreaLoading}
              setMessage={(value, e) => handleMessage(value, e, "ai-reply")}
              size={iconsSize}
            />
            )}
            {showAttachment && (
            <HToolTip title="Attachment">
              <div>
                <MediaUploadIconWrapper
                  source={source}
                  showMMS
                  fileList={fileList}
                  setFileList={setFileList}
                  integId={source !== "add-template" ? integrationId : null}
                  iconsSize={iconsSize}
                  contactId={contactId}
                />
              </div>
            </HToolTip>
            )}
            {/* Hiding schedule Message option for now , needs revamp in future */}
            {/* <DateAndTimePicker
              scheduledDate={scheduledDate}
              setScheduledDate={setScheduledDate}
              scheduledTime={scheduledTime}
              setScheduledTime={setScheduledTime}
              handleSendsms={handleSendsms}
            >
              <div className={`${enableSend ? "schedule-icon-active" : "schedule-icon"} actionIconsSprite`} />
            </DateAndTimePicker> */}
            {showEmoji && (
            <HToolTip title="Emoji">
              <div className="">
                <EmojiWrapper
                  cursorPositionRef={cursorPositionRef}
                  handleEmoji={handleMessage}
                  iconsSize={iconsSize}
                  chatView={chatView}
                  message={message}
                />
              </div>
            </HToolTip>
            )}
            {chatView && handleOpenNotes && showNotes && (
              <HToolTip title="Notes">
                <div
                  className={`${iconsSize === "small" ? "hs-scale-0-8" : ""} actionIconsSprite2 message-area-notes-icon`}
                  onClick={handleOpenNotes}
                />
              </HToolTip>
            )}
            {showTemplateIcon && (
              <HToolTip title="Templates">
                <div
                  className="position-relative cursor-pointer"
                  onClick={() => {
                    if (!templateOpen && setTemplateOpen) {
                      setTemplateOpen(true);
                    }
                  }}
                >
                  <div className={`${iconsSize === "small" ? "hs-scale-0-8" : ""} actionIconsSprite2 new-template-icon position-relative`}>
                    <SavedTemplatesSelect
                      {...templateProps}
                      handleMessage={handleMessage}
                      setPreviewResponse={setPreviewResponse}
                      toNumber={toNumber}
                      appProperties={appProperties}
                      moduleName={moduleName}
                      handleMedia={handleMedia}
                      chatView={chatView}
                      integrationId={integrationId}
                      setMessageAreaLoading={setMessageAreaLoading}
                      placement="topRight"
                      showOnlyPopup={true}
                      dropdownStyle={chatView || xs ? { width: 170 } : { width: 300 }}
                    />
                  </div>
                </div>
              </HToolTip>
            )}
            {showVoiceRecording && (
              <VoiceRecordingButton
                appProperties={appProperties}
                fileList={fileList}
                handleMediaFileList={setFileList}
                integrationId={integrationId}
                contactId={contactId}
              />
            )}
          </div>
          <div className="ms-auto d-flex gap-2 align-items-center">
            {isContentPresent && showPreviewButton && (
              <div className={`preview-text cursor-pointer`} onClick={toggleDrawer}>
                Preview
              </div>
            )}
          </div>
        </Flex>
      </Flex>
    </div>
  );
}

export default MessagingAreaActionItems;

export function DateAndTimePicker(props) {
  const {
    scheduledDate,
    setScheduledDate,
    scheduledTime,
    setScheduledTime,
    handleSendsms,
    handleEditSchedule,
    handleDeleteMessage,
    task,
    children,
  } = props;
  const [showSchedulePopup, setShowSchedulePopup] = useState(false);

  const handleSchedule = () => {
    if (scheduledDate && scheduledTime) {
      handleSendsms({ isScheduled: true });
      setShowSchedulePopup(false);
    } else {
      HNotification.notify({type: "warning", message: "Warning", description: "Please select date and time to schedule the message"});
    }
  };
  return (
    <Popover
      title={`${task === "edit" ? "Reschedule/Delete" : "Schedule"} Message`}
      trigger="click"
      placement="topLeft"
      content={
        <div className="d-flex align-items-end  flex-column">
          <DateAndTimePickerComponent
            scheduledDate={scheduledDate}
            setScheduledDate={setScheduledDate}
            scheduledTime={scheduledTime}
            setScheduledTime={setScheduledTime}
          />
          {task === "edit" ? (
            <div className="d-flex align-items-center gap-2">
              <HButton className="" type="primary" ghost onClick={() => handleEditSchedule()}>
                Edit
              </HButton>
              <HButton className="" type="primary" ghost onClick={() => handleDeleteMessage()}>
                Delete
              </HButton>
            </div>
          ) : (
            <HButton buttonClassName="w-100" type="primary" ghost onClick={() => handleSchedule()}>
              Schedule
            </HButton>
          )}
        </div>
      }
      open={showSchedulePopup}
      onOpenChange={setShowSchedulePopup}
    >
      <div onClick={() => setShowSchedulePopup(true)}>{children}</div>
    </Popover>
  );
}
